import { IconProps } from './types';

const Calendar = ({ className, strokeWidth }: IconProps) => {
    return (
        <svg
            className={className}
            fill="none"
            height="25"
            viewBox="0 0 24 25"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            role="img"
            strokeWidth={strokeWidth}
        >
            <g
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path d="m17.8006 5.60156h-11.20053c-.88369 0-1.60007.71638-1.60007 1.60008v11.20056c0 .8836.71638 1.6 1.60007 1.6h11.20053c.8837 0 1.6001-.7164 1.6001-1.6v-11.20056c0-.8837-.7164-1.60008-1.6001-1.60008z" />
                <path d="m15.4004 4v3.20015" />
                <path d="m9.00024 4v3.20015" />
                <path d="m5 10.3965h14.4007" />
            </g>
        </svg>
    );
};

export default Calendar;
